export default __webpack_public_path__ + "static/media/en-language.5b0e06f2.jpeg";